import type { Dictionary } from "./types";

export const it: Dictionary = {
  nav: { about: "Chi siamo", services: "Cosa facciamo", method: "Come lavoriamo", locations: "Sedi", contact: "Contatti" },
  hero: {
    title: "Intelligenza artificiale, integrata nei tuoi processi.",
    subtitle:
      "TUXIA è una software house innovativa: progettiamo piattaforme cloud e soluzioni AI che trasformano bisogni aziendali complessi in strumenti digitali semplici e scalabili.",
    cta: "Contattaci",
  },
  about: {
    heading: "Chi siamo",
    badge: "Startup innovativa",
    body: "Nata nel 2026, TUXIA S.R.L. è una start-up innovativa con sede in Veneto. Sviluppiamo software ad alto valore tecnologico con un focus particolare sull'integrazione dell'AI nei flussi di lavoro — privilegiando prodotti evolutivi, replicabili e integrabili rispetto a progetti su misura.",
    foundedLabel: "anno di fondazione",
  },
  services: {
    heading: "Cosa facciamo",
    items: [
      { title: "AI Integration", description: "Sistemi basati su AI: LLM, RAG, machine learning, NLP e computer vision integrati nei tuoi processi." },
      { title: "Piattaforme Cloud", description: "Piattaforme software cloud scalabili e sicure, erogate in modalità SaaS e PaaS." },
      { title: "Data & Analytics", description: "Data analysis, big data management e data mining per estrarre valore dai tuoi dati." },
      { title: "Process Automation", description: "Automazione dei processi aziendali (RPA) e analisi predittiva per più efficienza." },
      { title: "Cybersecurity", description: "Sicurezza avanzata e protezione dell'integrità di dati e modelli AI." },
    ],
  },
  method: {
    heading: "Come lavoriamo",
    intro: "Un metodo iterativo e trasparente, costruito attorno alle reali esigenze del tuo business.",
    steps: [
      {
        number: "01",
        title: "Scoperta",
        description: "Ascoltiamo e analizziamo: capiamo il contesto, i flussi di lavoro esistenti e gli obiettivi di business prima di scrivere una riga di codice.",
      },
      {
        number: "02",
        title: "Progettazione",
        description: "Definiamo architettura, stack tecnologico e roadmap. Ogni scelta tecnica è motivata da requisiti concreti, non da mode del momento.",
      },
      {
        number: "03",
        title: "Sviluppo",
        description: "Cicli brevi e iterativi: rilasci frequenti, feedback continuo, qualità verificata. Il prodotto cresce in modo controllato e misurabile.",
      },
      {
        number: "04",
        title: "Evoluzione",
        description: "Il software non finisce al go-live. Monitoriamo, ottimizziamo e facciamo evolvere il prodotto insieme a te nel tempo.",
      },
    ],
  },
  locations: {
    heading: "Sedi",
    registeredLabel: "Sede legale",
    operationalLabel: "Sede operativa",
    mapsCta: "Apri in Maps",
  },
  contact: {
    heading: "Contatti",
    body: "Hai un progetto o una domanda? Scrivici, ti rispondiamo presto.",
    cta: "Scrivici",
  },
  footer: {
    statusLabel: "Start-up innovativa",
    vatLabel: "P.IVA / C.F.",
    reaLabel: "REA",
    capitalLabel: "Capitale sociale",
    registeredOfficeLabel: "Sede legale",
    privacyLabel: "Privacy Policy",
    termsLabel: "Termini di servizio",
    rights: "Tutti i diritti riservati.",
  },
};
